import { createApi } from '@reduxjs/toolkit/query/react';
import { carBaseQuery } from '@app/api/carBaseQuery';
import type { MeetingGuidanceResponse } from '../types';
import { API_BASE_PATH } from '../constants';

interface MeetingGuidanceRequest {
  planResultRootId: string;
  planResultTypeId: string;
}

export const meetingGuidanceApi = createApi({
  reducerPath: 'meetingGuidanceApi',
  baseQuery: carBaseQuery,
  endpoints: (builder) => ({
    getMeetingGuidance: builder.query<
      MeetingGuidanceResponse,
      MeetingGuidanceRequest
    >({
      query: ({ planResultRootId, planResultTypeId }) => ({
        url: `${API_BASE_PATH}/${planResultRootId}/${planResultTypeId}/meeting-guidance/`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetMeetingGuidanceQuery } = meetingGuidanceApi;
